"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseStatus = void 0;
var spoonClient_1 = require("../spoonClient");
Object.defineProperty(exports, "ResponseStatus", { enumerable: true, get: function () { return spoonClient_1.ResponseStatus; } });
/**
 * Mockable HTTP client for testing purposes when API endpoints do not exist.
 */
var TestHttpClient = /** @class */ (function () {
    function TestHttpClient(config, responses, local) {
        this.config = config;
        this.responses = responses;
        this.local = local;
        this.http = new spoonClient_1.HttpClient(config);
        this.responseKeys = Object.keys(responses);
    }
    /**
     * Converts objects to url params.
     */
    TestHttpClient.objectsToParams = function (data) {
        return Object.keys(data).map(function (key) {
            return "".concat(key, "=").concat(encodeURIComponent(String(data[key])));
        }).join('&');
    };
    /**
     * Builds url from HttpRequest.
     */
    TestHttpClient.prototype.buildUrl = function (httpRequest) {
        var _this = this;
        var requestUrl = (function () {
            if (_this.config.baseUrl == null) {
                return httpRequest.url;
            }
            else {
                var urlBase = _this.config.baseUrl.replace(/\/($)/g, '$1');
                var providedUrl = httpRequest.url.replace(/(^)\//g, '$1');
                return "".concat(urlBase, "/").concat(providedUrl);
            }
        })();
        if (httpRequest.urlParams != null && Object.keys(httpRequest.urlParams).length > 0) {
            requestUrl += "?".concat(TestHttpClient.objectsToParams(httpRequest.urlParams));
        }
        return requestUrl;
    };
    /**
     * Builds test response key from HttpRequest.
     */
    TestHttpClient.prototype.buildTestKey = function (httpRequest) {
        var url = httpRequest.url, method = httpRequest.method, urlParams = httpRequest.urlParams;
        var key = url.replace(/(^)\//g, '$1').replace(/\/($)/g, '$1');
        key = "".concat(method, " /").concat(key);
        if (urlParams != null && Object.keys(urlParams).length > 0) {
            key += "?".concat(TestHttpClient.objectsToParams(urlParams));
        }
        return key;
        //
        // let requestUrl = httpRequest.url;
        //
        // if (httpRequest.urlParams != null && Object.keys(httpRequest.urlParams).length > 0) {
        //   requestUrl += `?${TestHttpClient.objectsToParams(httpRequest.urlParams)}`;
        // }
        //
        // return `${httpRequest.method} ${requestUrl}`;
    };
    /**
     * Builds test response key from method, url, and url params.
     */
    TestHttpClient.prototype.getTestKey = function (method, url, urlParams) {
        var key = url.replace(/(^)\//g, '$1').replace(/\/($)/g, '$1');
        key = "".concat(method, " /").concat(key);
        if (urlParams != null && Object.keys(urlParams).length > 0) {
            key += "?".concat(TestHttpClient.objectsToParams(urlParams));
        }
        if (this.responses[key] || this.responses[key] === false) {
            return key;
        }
        for (var _i = 0, _a = this.responseKeys; _i < _a.length; _i++) {
            var k = _a[_i];
            if (key.match(k)) {
                return k;
            }
        }
        return key;
    };
    /**
     * Send request function that mocks sending a request
     * and instead uses a defined test response when invoking the callback.
     */
    TestHttpClient.prototype.sendRequest = function (testKey, httpRequest, callback) {
        httpRequest = this.config.transformRequest ? this.config.transformRequest(httpRequest) : httpRequest;
        var url = this.buildUrl(httpRequest);
        // const testKey = this.buildTestKey(httpRequest);
        var response = this.responses[testKey] ? this.responses[testKey] : TestHttpClient.DEFAULT_RESPONSE;
        if (typeof response === 'function') {
            var key = this.buildTestKey(httpRequest);
            var keyMatch = key.match(testKey) || [];
            response = response(keyMatch || {}, httpRequest.body || null) || TestHttpClient.DEFAULT_RESPONSE;
        }
        console.log("Mocking request to url ".concat(url, ". Looking for test response ['").concat(testKey, "']"), response);
        callback(httpRequest, response);
    };
    /**
     * GET method.
     */
    TestHttpClient.prototype.get = function (url, urlParams, callback, headers, responseType) {
        var request = new spoonClient_1.HttpRequest('GET', url, urlParams, null, headers || null, responseType);
        var testKey = this.buildTestKey(request);
        var key = this.getTestKey('GET', url, urlParams);
        if (this.responses[key] === true) {
            console.log("Making actual request '".concat(key, "'..."));
            this.http.get(url, urlParams, callback, headers, responseType);
            return;
        }
        this.sendRequest(key, request, callback);
    };
    /**
     * PUT method.
     */
    TestHttpClient.prototype.put = function (url, urlParams, body, callback, headers, responseType) {
        var request = new spoonClient_1.HttpRequest('PUT', url, urlParams, body, headers || null, responseType);
        var key = this.getTestKey('PUT', url, urlParams);
        if (this.responses[key] === true) {
            console.log("Making actual request '".concat(key, "'..."));
            this.http.put(url, urlParams, body, callback, headers, responseType);
            return;
        }
        this.sendRequest(key, request, callback);
    };
    /**
     * POST method.
     */
    TestHttpClient.prototype.post = function (url, urlParams, body, callback, headers, responseType) {
        var request = new spoonClient_1.HttpRequest('POST', url, urlParams, body, headers || null, responseType);
        var key = this.getTestKey('POST', url, urlParams);
        if (this.responses[key] === true) {
            console.log("Making actual request '".concat(key, "'..."));
            this.http.post(url, urlParams, body, callback, headers, responseType);
            return;
        }
        this.sendRequest(key, request, callback);
    };
    /**
     * DELETE method.
     */
    TestHttpClient.prototype.del = function (url, urlParams, callback, headers, responseType) {
        var request = new spoonClient_1.HttpRequest('DELETE', url, urlParams, null, headers || null, responseType);
        var key = this.getTestKey('DELETE', url, urlParams);
        if (this.responses[key] === true) {
            console.log("Making actual request '".concat(key, "'..."));
            this.http.del(url, urlParams, callback, headers, responseType);
            return;
        }
        this.sendRequest(key, request, callback);
    };
    TestHttpClient.DEFAULT_RESPONSE = {
        status: spoonClient_1.ResponseStatus.ClientFailure,
        statusCode: 404,
        responseJson: null,
        responseText: 'Test response for method and url not provided.',
        response: null,
    };
    return TestHttpClient;
}());
exports.default = TestHttpClient;
//# sourceMappingURL=TestHttpClient.js.map